import { render } from "./OrderCreate.vue?vue&type=template&id=16e8ac3c"
import script from "./OrderCreate.vue?vue&type=script&lang=js"
export * from "./OrderCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__